import { useLayoutEffect, useState, type RefObject } from 'react'

/**
 * Проверяет, обрезан ли элемент визуально или выходит ли его содержимое за границы.
 *
 * Возвращает `true`, если у элемента есть скрытый контент по горизонтали или вертикали,
 * например когда текст обрезан через `line-clamp`. Значение пересчитывается при первом
 * рендере и при изменении размера элемента.
 */
export const useIsClamped = <TElement extends HTMLElement>(
  ref: RefObject<TElement | null>,
): boolean => {
  const [isClamped, setIsClamped] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current

    if (!element) {
      return
    }

    const updateIsClamped = () => {
      setIsClamped(
        element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth,
      )
    }

    updateIsClamped()

    const resizeObserver = new ResizeObserver(updateIsClamped)
    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [ref])

  return isClamped
}
